import { useState, useEffect } from "react";
import StepJumio from "@/pages/lagacyUser/jumio";
import StepAddress from "@/pages/lagacyUser/whiteAddress";
import { getKyvLegacyProcessInfo } from "@/pages/lagacyUser/api.js";
import PageWrap from "@/components/PageWrap";

const ClearOutUser = () => {
  const [step, setStep] = useState(""); // jumio | whiteAddress

  const _getKyvLegacyProcessInfo = async () => {
    localStorage.setItem("login_redirect", "/trade/offboard");
    const res = await getKyvLegacyProcessInfo({});
    console.log("_getKyvLegacyProcessInfo", res);
    if (res?.code === 0) {
      localStorage.removeItem("login_redirect", "/trade/offboard");
      if (["PENDING", "APPROVED"].includes(res?.data?.process[0]?.status)) {
        setStep("whiteAddress");
      } else {
        setStep("jumio");
      }
    }
  };

  useEffect(() => {
    _getKyvLegacyProcessInfo();
  }, []);

  return (
    <PageWrap>
      {step === "jumio" && <StepJumio setStep={setStep} />}
      {step === "whiteAddress" && <StepAddress />}
    </PageWrap>
  );
};

export default ClearOutUser;
